import styled from "styled-components";
import { ZingTheme } from '../../../../../../shared/src/assets/theme/types'
import {
  HUB_SIDEBAR_WIDTH_COLLAPSED,
  HUB_SIDEBAR_WIDTH_OPEN,
} from '../../../../../../shared/src/constants/breakpoints'

export const HotsitePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const HotsiteContentWrapper = styled.div`
  flex: 1 0 auto;
  min-width: 0;
  background-color: ${({ theme }) => (theme as ZingTheme).colors.purple50};
`;

export const FixedPageTopWrapper = styled.div<{ $isSidebarOpen: boolean }>`
  position: fixed;
  top: 0;
  left: ${({ $isSidebarOpen }) =>
    $isSidebarOpen ? HUB_SIDEBAR_WIDTH_OPEN : HUB_SIDEBAR_WIDTH_COLLAPSED};
  width: calc(
    100% -
      ${({ $isSidebarOpen }) =>
        $isSidebarOpen ? HUB_SIDEBAR_WIDTH_OPEN : HUB_SIDEBAR_WIDTH_COLLAPSED}
  );
  z-index: 51;
`;
